import { chatBotConfigApiUrl as apiUrl } from "@/apps/person-registration/services/apiClient/apiUrl";
import { apiClient } from "@/apps/person-registration/services/apiClient/apiClient";
import { IChatBotConfigResponse } from "../models/IChatBotConfigState";

/**
 * To get correct chatbot configuration based registrationTag
 * @param registationTag string
 * @returns chatbot configuration
 */

export const getChatBotConfiguration = async (
  registrationTag: string
): Promise<IChatBotConfigResponse> => {
  const response = await apiClient.get(apiUrl.CHATBOT_CONFIGURATION, {
    params: {
      registrationTag,
    },
  });
  return response.data as IChatBotConfigResponse;
};
